export default __webpack_public_path__ + "static/media/kolawole.dd1551b2.jpg";